<template>
  <div class="integration_content">
    <IntegrationForm />
  </div>
</template>
<script>
import IntegrationForm from "./Integration/IntegrationForm.vue";
export default {
  components: {
    IntegrationForm,
  },
};
</script>
<style scpoed>
.integration_content {
  overflow: auto;
  height: calc(100% - 128px);
  width: 100%;
  padding: 62px 38px 38px 38px;
}
</style>
